import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import {
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Checkbox,
  ListItemText,
} from '@material-ui/core'
import PropType from 'prop-types'
import { isEqual, unionBy } from 'lodash'
import cn from 'classnames'
import ArrowIcon from '@material-ui/icons/ArrowDropDown'
import CircularProgress from '@material-ui/core/CircularProgress'
import messages from './translate'

class TableMultiSelect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: this.props.value,
      allSelected: true,
      setAllSelected: false,
    }
  }

  componentDidMount() {
    const { name, setInitialData, value, data } = this.props
    const allSelected =
      name === 'data_fields' && setInitialData && isEqual(value, data)

    this.setState({ allSelected })
  }

  componentDidUpdate(prevProps) {
    const { allSelected, setAllSelected } = this.state
    const {
      value,
      data,
      setInitialData,
      name,
      activeSite,
      allSelectedExistInList,
    } = this.props
    const { value: prevValue, activeSite: prevActiveSite } = prevProps

    if (!isEqual(value, prevValue)) {
      this.setState({ value })
    }

    if (
      !allSelected &&
      isEqual(value, data) &&
      setInitialData &&
      name !== 'data_fields'
    ) {
      this.setState({ allSelected: true })
    }

    if (allSelected && value.length !== data.length && !setInitialData) {
      this.setState({ allSelected: false })
    }

    if (isEqual(value, data) && !setAllSelected) {
      this.setState({
        allSelected: true,
        setAllSelected: true,
      })
    }

    if (allSelectedExistInList && activeSite !== prevActiveSite) {
      this.setState({ setAllSelected: false }, () => {
        if (!allSelected && isEqual(value, data) && !setAllSelected) {
          this.setState({
            allSelected: true,
            setAllSelected: true,
          })
        }
      })
    }
  }

  findElement(arr, id) {
    return arr.find(item => item.id === Number(id) || item.id === id)
  }

  onChangeValue = event => {
    const { value: values } = this.state
    const { value } = event.target
    const {
      textContent,
      dataset: { id },
    } = event.currentTarget
    const {
      data,
      intl: { formatMessage },
    } = this.props
    let checkObj
    let existItem
    let newArr = []
    let resArr = []

    const allSelectedItem = formatMessage(messages.allSelected)

    if (!textContent.includes(allSelectedItem)) {
      if (values && values.length > 0) {
        newArr = [...values]
        existItem = this.findElement(newArr, id)
        checkObj = existItem && Object.keys(existItem)
      }

      if (checkObj && checkObj.length > 0) {
        resArr = newArr.filter(({ id }) => id !== existItem.id)
      } else {
        const newItem = this.findElement(data, id)
        const newValue = unionBy(value, 'id')
        const filteredArr = newValue.filter(({ id }) => id === newItem.id)

        if (newArr && newArr.length > 0) {
          resArr = [...newArr, ...filteredArr]
        } else {
          resArr = [...filteredArr]
        }
      }
    } else {
      resArr = []
      if (!this.state.allSelected) {
        resArr = [...data]
      }
    }

    this.setState({ value: resArr }, this.allItemsSelected)
  }

  allItemsSelected() {
    const { value } = this.state
    const { data, handleSetInitialData, allSelectedExistInList } = this.props
    const allSelected = value.length === data.length
    if (allSelectedExistInList) {
      handleSetInitialData(allSelected)
    }
    this.setState({ allSelected })
  }

  getRenderValue = () => {
    const { allSelected, value } = this.state
    const {
      allSelectedExistInList,
      intl: { formatMessage },
    } = this.props
    const sortedArr = value.sort((a, b) => a.count - b.count)

    if (allSelected && allSelectedExistInList) {
      return formatMessage(messages.allSelected)
    }

    const renderValues = []

    sortedArr.forEach(({ id, name }) => {
      if (id) {
        renderValues.push(typeof id === 'number' ? name : formatMessage({ id }))
      }
    })

    return renderValues.length ? renderValues.join(', ') : null
  }

  showRightIcon = () => {
    const { loader, SelectIcon } = this.props
    const checkIcon = !SelectIcon ? <ArrowIcon /> : <SelectIcon />

    return (
      <span className="select-loader">
        {loader ? <CircularProgress size={20} /> : checkIcon}
      </span>
    )
  }

  isSelected(item) {
    const { value } = this.state

    return value.some(({ id }) => id === item.id)
  }

  onClose = () => {
    const { onClose, storeName, data } = this.props
    onClose(this.state.value, storeName, data)
  }

  render() {
    const {
      name,
      label,
      disabled,
      disabledItem,
      data,
      value,
      autoWidth,
      meta,
      input,
      disableUnderline,
      MenuProps,
      lang,
      allSelectedExistInList,
      tableData,
      intl: { formatMessage },
    } = this.props

    const newData = data.map((item, i) => ({
      ...item,
      count: i,
    }))
    const spanish = lang === 'es' && 'spanish'
    const allSelectedItem = {
      id: '1',
      name: formatMessage(messages.allSelected),
    }
    const isDisabled = tableData.get('count') === 0
    const isDataFieldsDisabled = name === 'data_fields' && isDisabled
    const isDisabledSelect =
      name !== 'data_fields' && !value.length && !data.length

    return (
      <FormControl
        fullWidth
        disabled={isDataFieldsDisabled}
        component="div"
        className="select-filter multi-select">
        <InputLabel>{label}</InputLabel>
        <Select
          meta={meta}
          input={input}
          multiple
          id={name}
          name={name}
          disabled={disabled || isDisabledSelect}
          autoWidth={autoWidth}
          value={value}
          onChange={this.onChangeValue}
          onClose={this.onClose}
          renderValue={this.getRenderValue}
          IconComponent={this.showRightIcon}
          disableUnderline={disableUnderline}
          MenuProps={MenuProps}
          className={cn([`${name}`], { spanish })}>
          {allSelectedExistInList && (
            <MenuItem className="multi-select-item" value={allSelectedItem}>
              <Checkbox
                href={null}
                color="primary"
                checked={this.state.allSelected}
              />
              <ListItemText primary={allSelectedItem.name} />
            </MenuItem>
          )}
          {newData.map(item => {
            const { name, id } = item

            return (
              <MenuItem
                key={`${name}-${id}`}
                className={cn('multi-select-item', {
                  'all-selected': allSelectedExistInList,
                })}
                disabled={disabledItem}
                value={item}
                data-id={id}>
                <Checkbox
                  href={null}
                  color="primary"
                  checked={this.isSelected(item)}
                />
                <ListItemText
                  primary={
                    typeof id === 'number' ? name : formatMessage({ id })
                  }
                />
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
    )
  }
}

export default connect(state => ({
  tableData: state.getIn(['logbook', 'tableData']),
  lang: state.getIn(['locale', 'lang']),
  activeSite: state.getIn(['profile', 'siteId']),
}))(injectIntl(TableMultiSelect))

TableMultiSelect.defaultProps = {
  value: [],
  data: [],
  label: '',
}

TableMultiSelect.propTypes = {
  name: PropType.string.isRequired,
  data: PropType.array,
  value: PropType.array,
  label: PropType.string,
}
